import { ICupom } from "../interface/ICupom";
import { TipoCupom } from "../enum/TipoCupom";

interface ValoresPedido {
    valorTotalProdutos: number;
    valorFrete: number;
}

interface ResultadoCalculo {
    valorTotalProdutos: number;
    valorFrete: number;
    valorTotalPedido: number;
    valorDescontoTotal: number;
}

/**
 * Calcula os valores do pedido considerando os cupons aplicados
 */
export const calcularValoresComCupons = (
    valores: ValoresPedido,
    cupons: ICupom[]
): ResultadoCalculo => {
    let valorTotalProdutos = valores.valorTotalProdutos;
    let valorFrete = valores.valorFrete;
    let valorDescontoTotal = 0;

    if (!cupons || cupons.length === 0) {
        return {
            valorTotalProdutos,
            valorFrete,
            valorTotalPedido: valorTotalProdutos + valorFrete,
            valorDescontoTotal: 0,
        };
    }

    // Separar cupons por tipo
    const cuponsTaxaEntrega = cupons.filter(
        (c) => c.tipo === TipoCupom.TAXA_ENTREGA
    );
    const cuponsPorcentagemProdutos = cupons.filter(
        (c) => c.tipo === TipoCupom.PORCENTAGEM_PRODUTOS
    );
    const cuponsTotal = cupons.filter((c) => c.tipo === TipoCupom.TOTAL);
    const cuponsPorcentagem = cupons.filter(
        (c) => c.tipo === TipoCupom.PORCENTAGEM
    );

    // Aplicar cupons de taxa de entrega primeiro
    // Para TAXA_ENTREGA, o desconto é o valor total do frete (não usa cupom.valor)
    cuponsTaxaEntrega.forEach((cupom) => {
        // Se o cupom tem valor definido, usa esse valor, senão desconta o frete inteiro
        const desconto = cupom.valor !== null && cupom.valor !== undefined 
            ? cupom.valor 
            : valorFrete;
        valorFrete = Math.max(0, valorFrete - desconto);
        valorDescontoTotal += desconto;
    });

    // Aplicar cupons de porcentagem nos produtos
    cuponsPorcentagemProdutos.forEach((cupom) => {
        const porcentagem = cupom.valor || 0;
        const desconto = (valorTotalProdutos * porcentagem) / 100;
        valorTotalProdutos = Math.max(0, valorTotalProdutos - desconto);
        valorDescontoTotal += desconto;
    });

    // Calcular valor total antes de aplicar cupons no total
    let valorTotalPedido = valorTotalProdutos + valorFrete;

    // Aplicar cupons de valor fixo no total
    cuponsTotal.forEach((cupom) => {
        const desconto = cupom.valor || 0;
        valorTotalPedido = Math.max(0, valorTotalPedido - desconto);
        valorDescontoTotal += desconto;
    });

    // Aplicar cupons de porcentagem no total
    cuponsPorcentagem.forEach((cupom) => {
        const porcentagem = cupom.valor || 0;
        const desconto = (valorTotalPedido * porcentagem) / 100;
        valorTotalPedido = Math.max(0, valorTotalPedido - desconto);
        valorDescontoTotal += desconto;
    });

    return {
        valorTotalProdutos,
        valorFrete,
        valorTotalPedido,
        valorDescontoTotal,
    };
};

